import { Helmet } from 'react-helmet-async';
import ErrorView from 'src/sections/error';
// sections

// ----------------------------------------------------------------------

export default function Page401() {
  return (
    <>
      <Helmet>
        <title> 401 Unauthorized</title>
      </Helmet>

      <ErrorView variant="401" />
    </>
  );
}
